module.exports = __webpack_public_path__ + "img/spitter-attack-4.3db3b545.png";